export const REQUEST_VENUE_FETCH_EM = "REQUEST_VENUE_FETCH_EM";
export const FETCH_VENUE_EM_SUCCESS = "FETCH_VENUE_EM_SUCCESS";
export const FETCH_VENUE_EM_FAILURE = "FETCH_VENUE_EM_FAILURE";

export const CLEAR_FETCH_VENUE_EM_STATES = "CLEAR_FETCH_VENUE_EM_STATES";
